import _ from "lodash";
import { FileInfo } from "src/ui/containers/dashboard/files/types";
import { createRolloutTag } from "src/ui/containers/dashboard/shared/tags";

import { rankItem } from "@tanstack/match-sorter-utils";
import { FilterFn, Row } from "@tanstack/react-table";

// Convert from 0-based indexing (frontend) to 1-based indexing (backend API)
export const pageIndexOffset = 1;

export const fuzzyFilter: FilterFn<unknown> = (row, columnId, value, addMeta) => {
    const itemRank = rankItem(row.getValue(columnId), value as string);
    addMeta({ itemRank });
    return itemRank.passed;
};
export const uploaderFilter = <T extends FileInfo>(row: Row<T>, _columnId: string, filterValue: ("user" | "device")[]) => {
    const isUser = filterValue.includes("user");
    const isDevice = filterValue.includes("device");
    const isUploadedByDevice = row.original.source === 1;

    if (!filterValue.length) {
        return true;
    }

    if (isUser && isDevice) {
        return true;
    }

    if (isUser && !isUploadedByDevice) {
        return true;
    }

    if (isDevice && isUploadedByDevice) {
        return true;
    }

    return false;
};

export const tagsFilter = <T extends API.File>(row: Row<T>, _columnId: string, filterValue: unknown) => {
    if (!filterValue || (Array.isArray(filterValue) && !filterValue.length)) {
        return true;
    }

    const removableTags = row.original.metadata?.user?.tags || [];
    const rolloutTag = createRolloutTag(row.original.rolloutPercentage);
    const tags = [rolloutTag, ...removableTags].filter(Boolean);
    const tagsKeys = tags.map((tag) => tag?.key);

    return _.some(filterValue, (i) => _.includes(tagsKeys, i));
};
